import React from 'react';
import { FadeIn } from './FadeIn';
export function HeroSection() {
  return <section className="bg-brand-navy text-white pt-20 pb-24 px-6 relative overflow-hidden" data-id="element-98">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-99">
        <FadeIn data-id="element-100">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-white" data-id="element-101">
            The <span className="text-brand-teal" data-id="element-102">Reverse-Scroll</span> Method:
            Turn Your Teen's Screen Time into a Local Micro-Agency
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-103">
          <h2 className="text-xl md:text-2xl font-body font-normal text-gray-200 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-104">
            Stop fighting over "brain rot" scrolling and help your teen launch a
            $500/mo digital service for local businesses in the next 14 days.
          </h2>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-105">
          <a href="#offer" className="inline-block bg-brand-teal text-white font-bold text-lg md:text-xl py-4 px-10 rounded-full shadow-[0_4px_14px_0_rgba(0,212,170,0.39)] hover:shadow-[0_6px_20px_rgba(0,212,170,0.23)] hover:bg-[#00e6b8] transition-all duration-300 mb-16 transform hover:-translate-y-1" data-id="element-106">
            GET THE REVERSE-SCROLL METHOD NOW
          </a>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-107">
          <div className="relative mx-auto max-w-3xl rounded-2xl overflow-hidden shadow-2xl border-4 border-white/10" data-id="element-108">
            <img src="https://cdn.magicpatterns.com/uploads/owWaYPGKs5qar3MvJgHs1o/the_reverse_scroll_method_family_image.png" alt="Family looking at a laptop together, smiling and engaged" className="w-full h-auto object-cover" data-id="element-109" />
            <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/40 to-transparent mix-blend-multiply" data-id="element-110"></div>
          </div>
        </FadeIn>
      </div>
    </section>;
}